import { Message } from 'element-ui'
import router from '../router/index'

const install = (Vue,vm) => {
  //Vue就是Vue对象（不是创建出的实例）
  //vm就是页面中的vue实例每一个this,在这里可以访问到this的所有属性
  //baseUrl 为项目代理前缀
  Vue.prototype.$axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
  Vue.prototype.$axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
  Vue.prototype.$axios.defaults.timeout = 10000;
  //请求拦截器
  Vue.prototype.$axios.interceptors.request.use(config => {
      //可以在此判断要不要加Token
      if(vm.$route.path != '/login'){
        if(vm.$store.state.token){
          config.headers['Authorization'] = 'Bearer ' + vm.$store.state.token
        }
      }
      return config
    },
    err => {
      Promise.reject(err)
    }
    )
  //响应拦截器
  Vue.prototype.$axios.interceptors.response.use(
    res => {
      let {code,data,msg} = res.data
      if(code !== 200){
        if(code === 401){
          localStorage.removeItem('token')
          if(location !== '#/login'){
            router.replace('/login')
            return false;
          }
        }else{
          Message.warning(data || msg || '网络异常')
          return false
        }
      }
      return res.data
    },
    err => {
      if(err?.response?.status){
        let {status} = err.response
        if(status === 401){
          localStorage.removeItem('token')
          if(location !== '#/login'){
            router.replace('/login')
            return false;
          }
        }else if(status === 502){
          Message.warning('服务器正在部署,请稍候~')
          return false;
        }else{
          Message.warning(`${err.response.data.error} ==>>>>   ` + status)
        }
      }else{
        Message.warning('服务异常')
      }
      return false;
    }
  )
}


export default {
  install
}